import React from 'react';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CloseBold from '@wix/da-ds/pkg/Icons/CloseBold';
import noop from '../../utils/noop';
import AlternatePopoverContent from '../PopoverContent/AlternatePopoverContent';
import s from './BasicTooltip.scss';
/** This is basically a wrapper to keep this component working without updating all consumers for now
 * TODO: clean this shit up
 */ const BasicTooltip = /*#__PURE__*/ React.forwardRef(({ wrapperClassName, contentClassName, withCloseButton, closeOnOutsideClick = true, placement, children, secondaryPlacement, onClose = noop }, innerRef)=>{
    return /*#__PURE__*/ React.createElement(AlternatePopoverContent, {
        ref: innerRef,
        effectivePlacement: placement,
        effectiveSecondaryPlacement: secondaryPlacement,
        wrapperClassName: wrapperClassName,
        contentClassName: contentClassName,
        onClickOutside: closeOnOutsideClick ? onClose : undefined
    }, children, withCloseButton && /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['close'],
        onClick: onClose
    }, /*#__PURE__*/ React.createElement(CloseBold, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    })));
});
BasicTooltip.displayName = 'BasicTooltip';
export default BasicTooltip;
